import { UEListData } from "@/app/interface/homepage";
import React from "react";

interface AboutBasketProps {
    basketDetails: UEListData[] | null;
}
export const AboutBasket = ({ basketDetails }: AboutBasketProps) => {
    return (
        <div className="mb-s17 mt-14 md:mt-0">
            <h3 className="text-xl font-semibold leading-[130%] tracking-[-0.24px] text-neutral-900 md:mb-s11 md:text-3xl">
                About the Diversified Basket
            </h3>
            <ul className="mt-s9 list-disc space-y-4 pl-5">
                <li className="text-sm font-regular tracking-[0.14px]">
                    Our basket features {basketDetails?.length} stocks with high growth potential
                    across a diverse range of industries. This ensures that you get a diversified
                    portfolio which is insulated from risks from a particular sector.
                </li>
                {basketDetails &&
                    basketDetails.map((item, index) => {
                        return (
                            <li key={index} className="text-sm font-regular tracking-[0.14px]">
                                {item?.company?.displayName}: {item?.company?.description}
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
};
